<div class="container">
  @if (measureMode) {
    <div class="pill">
      <span class="pill-text">{{ measurement }}</span>
      <button
        color="primary"
        class="pill-close-btn"
        style="color: white"
        (click)="onCloseClicked()"
        >
        &#10005;
      </button>
    </div>
  }

  @if (!measureMode) {
    <button
      color="primary"
      class="icon button"
      (click)="onMeasuredMapClicked('Area')"
      >
      <span class="material-symbols-outlined">square_foot</span>
    </button>
  }

  @if (!measureMode) {
    <button
      color="primary"
      class="icon button"
      (click)="onMeasuredMapClicked('Distance')"
      >
      <span class="material-symbols-outlined">Straighten</span>
    </button>
  }
</div>
